import { render, staticRenderFns } from "./LoaLab5.vue?vue&type=template&id=7cc0d5e6&"
import script from "./LoaLab5.vue?vue&type=script&lang=js&"
export * from "./LoaLab5.vue?vue&type=script&lang=js&"
import style0 from "./LoaLab5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports